import React from "react";
import {TableCell} from '@aws-amplify/ui-react';

function CodecCell(props) {
  return (
      <>
        <TableCell className="synamedia-td">
          {
            props.distorted ?
                props.distorted.spec_codec
                :
                ''
          }
        </TableCell>
      </>
  );
}

export default CodecCell;
